module.exports = __webpack_public_path__ + "1c3ebf00b16abce6ae71268329f9de15.jpg";